/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionReferenceTypeEnum } from './subscriptionReferenceTypeEnum';
import { UsersImportCollumns } from './usersImportCollumns';
import { SupervisorType } from './supervisorType';


/**
 * 
 */
export interface PickUsersImportReferenceTypeColumnsMappingTrainingIdsOrganisationIdLanguageCountryCodeRolesLicenseAccountIdLicenseFromLicenseToStudentNumberTypeCoordinatingSupervisorId { 
    /**
     * 
     */
    reference?: string;
    /**
     * 
     */
    type?: PickUsersImportReferenceTypeColumnsMappingTrainingIdsOrganisationIdLanguageCountryCodeRolesLicenseAccountIdLicenseFromLicenseToStudentNumberTypeCoordinatingSupervisorId.TypeEnum;
    columnsMapping: UsersImportCollumns;
    /**
     * 
     */
    trainingIds?: Array<number>;
    /**
     * 
     */
    organisationId?: number;
    /**
     * 
     */
    language?: string;
    /**
     * 
     */
    countryCode?: string;
    /**
     * 
     */
    roles?: Array<SupervisorType>;
    /**
     * 
     */
    licenseAccountId?: number;
    /**
     * 
     */
    licenseFrom?: string;
    /**
     * 
     */
    licenseTo?: string;
    studentNumberType?: SubscriptionReferenceTypeEnum;
    /**
     * 
     */
    coordinatingSupervisorId?: number;
}
export namespace PickUsersImportReferenceTypeColumnsMappingTrainingIdsOrganisationIdLanguageCountryCodeRolesLicenseAccountIdLicenseFromLicenseToStudentNumberTypeCoordinatingSupervisorId {
    export type TypeEnum = 'assistant' | 'supervisor' | 'supervisor-license';
    export const TypeEnum = {
        Assistant: 'assistant' as TypeEnum,
        Supervisor: 'supervisor' as TypeEnum,
        SupervisorLicense: 'supervisor-license' as TypeEnum
    };
}


